<template>
  <div id="app">
    <el-container>
      <el-header>
        <div style="display: flex;">
          <div class="logo">
            <img src="./assets/img/1024.png" alt />
          </div>
          <div class="title">雨后生活科技（杭州）有限公司</div>
        </div>
        <el-menu :default-active="defaultActive" class="el-menu-demo" mode="horizontal" @select="handleSelect"
          :router="router">
          <el-menu-item index="/">首页</el-menu-item>
          <el-menu-item index="/download">联系我们</el-menu-item>
        </el-menu>
      </el-header>
      <el-main>
        <router-view />
      </el-main>
      <el-footer>
        <div class="footers">
<a href="https://beian.miit.gov.cn" style="text-decoration:none;color: rgb(150, 150, 150);">浙ICP备2023008083号</a>
<div style="margin-top: 4px;">查询网址工信部链接：<a href="https://beian.miit.gov.cn" style="text-decoration:none;color: rgb(116, 166, 200);">https://beian.miit.gov.cn</a></div>
</div>
      </el-footer>
    </el-container>
    
  </div>
</template>

<script>
export default {
  data() {
    return {
      router: true,
      defaultActive: "/",
      isShow: false
    };
  },
  methods: {
    handleSelect(key) {
      this.isShow = this.defaultActive != key;
      window.console.log(this.isShow);
    }
  }
};
</script>

<style lang="scss">
.footers{
    font-size: 13px;
text-align: center;
color: rgb(150, 150, 150);
// padding: 20px 0;
      margin-top: 10px;
}
* {
  padding: 0;
  margin: 0;
}

html,
body {
  height: 100%;
}

#app {
  font-family: "Avenir", Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  color: #2c3e50;
}

.el-header {
  display: flex;
  justify-content: space-between;
  align-content: center;
  width: 100%;
 
  margin: 0 auto;
  //background-color: #fff;

  .title{
    margin-top: 20px;
    font-size: 18px;
    color: #222;
    font-weight: bold;
  }
  .logo {
    width: 70px;
    box-sizing: border-box;
    img {
      width: 100%;
      // line-height: 80px;
    }
  }
}

.el-main {
  padding: 0 !important;
}

.footer {
  width: 100%;
  // height: 216px;
  overflow: hidden;
  background-color: #999;

  &-content {
    width: 1240px;
    margin: 0 auto;
    padding-top: 20px;
    display: flex;
    justify-content: space-between;

    .content-nav {
      display: flex;
      justify-content: space-around;

      li {
        display: flex;
        flex-direction: column;
        padding: 0 20px;
        //justify-content: center;
        align-items: flex-start;

        p {
          font-size: 20px;
          color: #d4edff;
          padding: 10px 0;
        }

        span {
          color: #f7f7f7;
          font-weight: 300;
          padding: 5px 0;
        }
      }
    }

    img {
      width: 170px;
      height: 170px;
      padding: 10px;
     }
  }

  .copyright {
    height: 30px;
    background: #999;

    span {
      color: #fff;
      line-height: 30px;
    }
  }
}
</style>